import { Button } from '@chakra-ui/react'
import { Plus } from 'lucide-react'
import { useThemeColors } from '@/hooks/useThemeColors'

type Props = {
  onClick?: () => void
  isDisabled?: boolean
  size?: 'sm' | 'md' | 'lg'
}

export function NewTicketButton({ onClick, isDisabled, size = 'sm' }: Props) {
  const colors = useThemeColors()

  return (
    <Button
      leftIcon={<Plus size={16} />}
      bg={colors.primary}
      _hover={{ bg: colors.primaryHover }}
      _active={{ bg: colors.buttonActiveBg }}
      color="white"
      size={size}
      onClick={onClick}
      isDisabled={isDisabled}
    >
      New Ticket
    </Button>
  )
}
